const getBaseClientHost = () => {
  if (import.meta.env.VITE_PUBLIC_CLIENT_HOST) {
    return import.meta.env.VITE_PUBLIC_CLIENT_HOST;
  }

  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }

  return "";
};

export const getRecruiterTrackingUrl = (
  jobId: string,
  recruiterUserId: string,
) => {
  const baseHost = getBaseClientHost();
  const basePath = `${baseHost}/jobs/${jobId}`;

  try {
    const url = new URL(basePath);
    url.searchParams.set("ref", recruiterUserId);
    return url.toString();
  } catch (error) {
    const separator = basePath.includes("?") ? "&" : "?";
    return `${basePath}${separator}ref=${encodeURIComponent(recruiterUserId)}`;
  }
};
